import { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import Dropdown from "@/components/shared/Dropdown"
import { AppDispatch, RootState } from "@/store"
import { setSelectedTenant } from "@/store/userSlice"
import { Variant } from "@/types/index"

function TenantSelector() {
   const dispatch = useDispatch<AppDispatch>()
   const { tenants, selectedTenantId } = useSelector(
      ({ userReducer }: RootState) => userReducer
   )
   const tenantsOptions = useMemo(() => {
      return tenants.map((tenant) => ({
         label: tenant.name,
         value: tenant.id,
         selected: tenant.id === selectedTenantId,
      }))
   }, [selectedTenantId, tenants])

   const handleDropdownChange = useCallback(
      (tenantId: string) => {
         if (tenantId === selectedTenantId) return

         dispatch(setSelectedTenant(tenantId))
      },
      [dispatch, selectedTenantId]
   )

   if (tenants.length <= 1) {
      return null
   }

   return (
      <span className="header__tenant-selector">
         <Dropdown
            size={Variant.LARGE}
            label="Tenant"
            options={tenantsOptions}
            onSelectionChange={(value) => handleDropdownChange(value[0])}
         />
      </span>
   )
}

export default TenantSelector
